import { MouseEventHandler } from 'react'
import { useTranslation } from 'react-i18next'

import { ROUTE_PATH } from 'lib/paths'
import { Group } from 'lib/_types'

import { Link } from 'features/i18n/router'

import './style.scss'
import { useGroupCategory } from 'hooks/useGroupCategory'

export const GroupCategoryLabel = ({
  group,
  ...other
}: {
  group: Group
  onClick?: MouseEventHandler<HTMLAnchorElement>
}) => {
  const { t } = useTranslation()
  const groupCategory = useGroupCategory(group)

  return (
    <Link
      to={ROUTE_PATH.GROUP(group?.id)}
      {...other}
      className="GroupCategoryLabel"
    >
      <img src={groupCategory.icon} />
      <span>{groupCategory.name}</span>
    </Link>
  )
}
